import { createContext, useContext, useState, useEffect } from "react";

import PropTypes from "prop-types";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

export const useBookmarkContent = () => {
  const bookmarkContentUrl = `${MONOLITH_ORIGIN}/api/v3/content-bookmark/`;

  return useRestQuery(bookmarkContentUrl);
};

const propTypes = {
  children: PropTypes.node,
};

const BookmarkContext = createContext();

/* The BookmarkContextProvider should be wrapped around the lowest common ancestor of multiple components that call useBookmarkContentContext (for e.g., BookmarkButton) and appear on the same page i.e, on the page-level or row-level */
export function BookmarkContextProvider({ children }) {
  const [bookmarkData, setBookmarkData] = useState([]);
  const { data } = useBookmarkContent();

  const bookmarksByContentId = (data || []).reduce((acc, content) => {
    acc[content.content_id] = { id: content.id };
    return acc;
  }, {});

  useEffect(() => {
    async function fetchData() {
      setBookmarkData(bookmarksByContentId);
    }
    fetchData();
  }, [data]);

  return (
    <BookmarkContext.Provider
      value={{
        bookmarkData,
        setBookmarkData,
      }}
    >
      {children}
    </BookmarkContext.Provider>
  );
}

// hook to access data from BookmarkContext
export function useBookmarkContentContext() {
  const bookmarkContext = useContext(BookmarkContext);

  if (bookmarkContext === undefined) {
    throw new Error(
      "useBookmarkContentContext must be used within a BookmarkContextProvider.",
    );
  }

  return bookmarkContext;
}

BookmarkContextProvider.propTypes = propTypes;

export default useBookmarkContentContext;
